<script setup>
import { useRoute } from 'vue-router'
import SaleDocumentGrid from '@/components/sale/SaleDocumentGrid.vue'

const route = useRoute()
</script>
<template>
  <sale-document-grid
    :key="route.meta.type"
    :type="route.meta.type"
  />
</template>
